import { Avatar, Text } from '@/shared/ui/primitives';
import type { FC } from 'react';

import { ClientOptions } from '@/features/clients';
import { getInitials } from '@/shared/lib/client';
import { TEST_IDS } from '@/testIds';
import type { ClientDetail } from '@/types';
import styles from './ClientProfileHeader.module.css';

interface ClientProfileHeaderProps {
  client: ClientDetail;
  onRename: () => void;
}

export const ClientProfileHeader: FC<ClientProfileHeaderProps> = ({ client, onRename }) => {
  return (
    <div className={styles.header}>
      <Avatar initials={getInitials(client.name)} size={48} data-testid={TEST_IDS.clientAvatar} />
      <div className={styles.identity}>
        <Text as="h1" variant="title" weight="bold" className={styles.name}>
          {client.name}
        </Text>
      </div>
      <ClientOptions clientId={client.id} onRename={onRename} />
    </div>
  );
};
